import { GET_QUESTIONS, VERIFY_ANSWER, SUBMIT_EXAM, MANAGE_ATTENDANCE, GET_CERTIFICATES_RETAILER, CERTIFICATE_STATUS, CLEAR_EXAM_STATE} from "redux/retailer-constants";

const initialState = {
  retailerCertificatesList: [],
  certificateQuestions: [],
  verifyAnswerData: null,
  examSubmitData: null,
  attendanceData: null,
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_CERTIFICATES_RETAILER: {
      return {
        ...state,
        retailerCertificatesList: payload,
      };
    }
    case GET_QUESTIONS: {
      return {
        ...state,
        certificateQuestions: payload,
      };
    }
    case VERIFY_ANSWER: {
      return {
        ...state,
        verifyAnswerData: payload,
      };
    }
    case SUBMIT_EXAM: {
      return {
        ...state,
        examSubmitData: payload,
      };
    }
    case CERTIFICATE_STATUS: {
      return {
        ...state,
        retailerCertificatesList: state.retailerCertificatesList.map(cert => 
          cert.certificationid === payload.certificationid
            ? { ...cert, completedstatus: "Completed" }
            : cert
        ),
      };
    }
    case MANAGE_ATTENDANCE: {
      return {
        ...state,
        attendanceData: payload,
      };
    }

    case CLEAR_EXAM_STATE: {
      return {
        ...state,
        certificateQuestions: [],
        verifyAnswerData: null,
        examSubmitData: null,
        attendanceData: null,
      };
    }
    default:
      return state;
  }
};

export default reducer;